import DataTableRole, { TABLE_COLUMN_ORDER } from './data-table';

const TABLE_ROLES = [DataTableRole];

export default TABLE_ROLES;
export { TABLE_ROLES, DataTableRole, TABLE_COLUMN_ORDER };
